<template>

</template>

<script>
    export default {
        name: "kuveyt"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Entegrasyon/Bankalar/kuveyt.vue